import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import type {ColorName} from 'shells/colors/colors';
import {SelectedFieldCard} from 'shells/form/sidebar-fields/selected-field-card';
import {CirclePlusRegularIcon} from 'shells/icon/svg/circle-plus-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import type {ListOption} from 'shells/select-option-components/option';

import {SelectTag} from '../../../forms/form-page/editor/mapping/additional-rules/select-tag';

export type SelectedTag = {
    id: string;
    label: string;
    colorName: ColorName;
};

type Props = {
    selectedTags: SelectedTag[];
    onChange: (tags: SelectedTag[]) => void;
};

export function TagSelectList(props: Props) {
    const {selectedTags, onChange} = props;
    const [isAddingNew, setIsAddingNew] = React.useState<boolean>(selectedTags.length === 0);

    const handleTagChange = (option: ListOption) => {
        const newTag: SelectedTag = {
            id: option.value,
            label: option.label,
            colorName: option.colorName || 'greyLt',
        };
        onChange([...selectedTags, newTag]);
        setIsAddingNew(false);
    };

    const handleRemove = (index: number) => {
        const newTags = selectedTags.filter((tag: SelectedTag, i: number) => i !== index);
        onChange(newTags);
        if (newTags.length === 0) {
            setIsAddingNew(true);
        }
    };

    const handleAddAnother = () => {
        setIsAddingNew(true);
    };

    return (
        <Stack spacing={4}>
            {selectedTags.map((tag, index) => (
                <SelectedFieldCard
                    key={tag.id}
                    name={tag.label}
                    onRemove={() => handleRemove(index)}
                    borderColor={tag.colorName ? colors[tag.colorName] : undefined}
                />
            ))}
            {isAddingNew ? (
                <SelectTag
                    tagType='CONTACT'
                    selectedId={null}
                    onChange={handleTagChange}
                    excludeIds={selectedTags.map((tag) => tag.id)}
                />
            ) : (
                <Button
                    variant='text-primary'
                    size='normal'
                    icon={CirclePlusRegularIcon}
                    onClick={handleAddAnother}
                    noPadding={true}
                >
                    Add another tag
                </Button>
            )}
        </Stack>
    );
}
